export default __webpack_public_path__ + "static/media/main-shield.863e26af.svg";